// Comprehensive list of nationalities based on ISO 3166-1 country codes
// Updated for 2024 with all recognized sovereign states and territories

export interface Nationality {
  value: string;
  label: string;
  countryCode: string;
}

export const nationalities: Nationality[] = [
  { value: "afghan", label: "Afghan", countryCode: "AF" },
  { value: "albanian", label: "Albanian", countryCode: "AL" },
  { value: "algerian", label: "Algerian", countryCode: "DZ" },
  { value: "american", label: "American", countryCode: "US" },
  { value: "andorran", label: "Andorran", countryCode: "AD" },
  { value: "angolan", label: "Angolan", countryCode: "AO" },
  { value: "antiguans", label: "Antiguan, Barbudan", countryCode: "AG" },
  { value: "argentinian", label: "Argentinean", countryCode: "AR" },
  { value: "armenian", label: "Armenian", countryCode: "AM" },
  { value: "australian", label: "Australian", countryCode: "AU" },
  { value: "austrian", label: "Austrian", countryCode: "AT" },
  { value: "azerbaijani", label: "Azerbaijani", countryCode: "AZ" },
  { value: "bahamian", label: "Bahamian", countryCode: "BS" },
  { value: "bahraini", label: "Bahraini", countryCode: "BH" },
  { value: "bangladeshi", label: "Bangladeshi", countryCode: "BD" },
  { value: "barbadian", label: "Barbadian", countryCode: "BB" },
  { value: "belarusian", label: "Belarusian", countryCode: "BY" },
  { value: "belgian", label: "Belgian", countryCode: "BE" },
  { value: "belizean", label: "Belizean", countryCode: "BZ" },
  { value: "beninese", label: "Beninese", countryCode: "BJ" },
  { value: "bhutanese", label: "Bhutanese", countryCode: "BT" },
  { value: "bolivian", label: "Bolivian", countryCode: "BO" },
  { value: "bosnian", label: "Bosnian, Herzegovinian", countryCode: "BA" },
  { value: "brazilian", label: "Brazilian", countryCode: "BR" },
  { value: "british", label: "British", countryCode: "GB" },
  { value: "bruneian", label: "Bruneian", countryCode: "BN" },
  { value: "bulgarian", label: "Bulgarian", countryCode: "BG" },
  { value: "burkinabe", label: "Burkinabe", countryCode: "BF" },
  { value: "burmese", label: "Burmese", countryCode: "MM" },
  { value: "burundian", label: "Burundian", countryCode: "BI" },
  { value: "cambodian", label: "Cambodian", countryCode: "KH" },
  { value: "cameroonian", label: "Cameroonian", countryCode: "CM" },
  { value: "canadian", label: "Canadian", countryCode: "CA" },
  { value: "cape_verdian", label: "Cape Verdean", countryCode: "CV" },
  { value: "central_african", label: "Central African", countryCode: "CF" },
  { value: "chadian", label: "Chadian", countryCode: "TD" },
  { value: "chilean", label: "Chilean", countryCode: "CL" },
  { value: "chinese", label: "Chinese", countryCode: "CN" },
  { value: "colombian", label: "Colombian", countryCode: "CO" },
  { value: "comoran", label: "Comoran", countryCode: "KM" },
  { value: "congolese", label: "Congolese", countryCode: "CG" },
  { value: "costa_rican", label: "Costa Rican", countryCode: "CR" },
  { value: "croatian", label: "Croatian", countryCode: "HR" },
  { value: "cuban", label: "Cuban", countryCode: "CU" },
  { value: "cypriot", label: "Cypriot", countryCode: "CY" },
  { value: "czech", label: "Czech", countryCode: "CZ" },
  { value: "danish", label: "Danish", countryCode: "DK" },
  { value: "djibouti", label: "Djibouti", countryCode: "DJ" },
  { value: "dominican", label: "Dominican", countryCode: "DM" },
  { value: "dutch", label: "Dutch", countryCode: "NL" },
  { value: "east_timorese", label: "East Timorese", countryCode: "TL" },
  { value: "ecuadorean", label: "Ecuadorean", countryCode: "EC" },
  { value: "egyptian", label: "Egyptian", countryCode: "EG" },
  { value: "emirian", label: "Emirian", countryCode: "AE" },
  { value: "equatorial_guinean", label: "Equatorial Guinean", countryCode: "GQ" },
  { value: "eritrean", label: "Eritrean", countryCode: "ER" },
  { value: "estonian", label: "Estonian", countryCode: "EE" },
  { value: "ethiopian", label: "Ethiopian", countryCode: "ET" },
  { value: "fijian", label: "Fijian", countryCode: "FJ" },
  { value: "filipino", label: "Filipino", countryCode: "PH" },
  { value: "finnish", label: "Finnish", countryCode: "FI" },
  { value: "french", label: "French", countryCode: "FR" },
  { value: "gabonese", label: "Gabonese", countryCode: "GA" },
  { value: "gambian", label: "Gambian", countryCode: "GM" },
  { value: "georgian", label: "Georgian", countryCode: "GE" },
  { value: "german", label: "German", countryCode: "DE" },
  { value: "ghanaian", label: "Ghanaian", countryCode: "GH" },
  { value: "greek", label: "Greek", countryCode: "GR" },
  { value: "grenadian", label: "Grenadian", countryCode: "GD" },
  { value: "guatemalan", label: "Guatemalan", countryCode: "GT" },
  { value: "guinea_bissauan", label: "Guinea-Bissauan", countryCode: "GW" },
  { value: "guinean", label: "Guinean", countryCode: "GN" },
  { value: "guyanese", label: "Guyanese", countryCode: "GY" },
  { value: "haitian", label: "Haitian", countryCode: "HT" },
  { value: "herzegovinian", label: "Herzegovinian", countryCode: "BA" },
  { value: "honduran", label: "Honduran", countryCode: "HN" },
  { value: "hungarian", label: "Hungarian", countryCode: "HU" },
  { value: "icelander", label: "Icelander", countryCode: "IS" },
  { value: "indian", label: "Indian", countryCode: "IN" },
  { value: "indonesian", label: "Indonesian", countryCode: "ID" },
  { value: "iranian", label: "Iranian", countryCode: "IR" },
  { value: "iraqi", label: "Iraqi", countryCode: "IQ" },
  { value: "irish", label: "Irish", countryCode: "IE" },
  { value: "israeli", label: "Israeli", countryCode: "IL" },
  { value: "italian", label: "Italian", countryCode: "IT" },
  { value: "ivorian", label: "Ivorian", countryCode: "CI" },
  { value: "jamaican", label: "Jamaican", countryCode: "JM" },
  { value: "japanese", label: "Japanese", countryCode: "JP" },
  { value: "jordanian", label: "Jordanian", countryCode: "JO" },
  { value: "kazakhstani", label: "Kazakhstani", countryCode: "KZ" },
  { value: "kenyan", label: "Kenyan", countryCode: "KE" },
  { value: "kittian_and_nevisian", label: "Kittian and Nevisian", countryCode: "KN" },
  { value: "kuwaiti", label: "Kuwaiti", countryCode: "KW" },
  { value: "kyrgyz", label: "Kyrgyz", countryCode: "KG" },
  { value: "laotian", label: "Laotian", countryCode: "LA" },
  { value: "latvian", label: "Latvian", countryCode: "LV" },
  { value: "lebanese", label: "Lebanese", countryCode: "LB" },
  { value: "liberian", label: "Liberian", countryCode: "LR" },
  { value: "libyan", label: "Libyan", countryCode: "LY" },
  { value: "liechtensteiner", label: "Liechtensteiner", countryCode: "LI" },
  { value: "lithuanian", label: "Lithuanian", countryCode: "LT" },
  { value: "luxembourger", label: "Luxembourger", countryCode: "LU" },
  { value: "macedonian", label: "Macedonian", countryCode: "MK" },
  { value: "malagasy", label: "Malagasy", countryCode: "MG" },
  { value: "malawian", label: "Malawian", countryCode: "MW" },
  { value: "malaysian", label: "Malaysian", countryCode: "MY" },
  { value: "maldivan", label: "Maldivan", countryCode: "MV" },
  { value: "malian", label: "Malian", countryCode: "ML" },
  { value: "maltese", label: "Maltese", countryCode: "MT" },
  { value: "marshallese", label: "Marshallese", countryCode: "MH" },
  { value: "mauritanian", label: "Mauritanian", countryCode: "MR" },
  { value: "mauritian", label: "Mauritian", countryCode: "MU" },
  { value: "mexican", label: "Mexican", countryCode: "MX" },
  { value: "micronesian", label: "Micronesian", countryCode: "FM" },
  { value: "moldovan", label: "Moldovan", countryCode: "MD" },
  { value: "monacan", label: "Monacan", countryCode: "MC" },
  { value: "mongolian", label: "Mongolian", countryCode: "MN" },
  { value: "moroccan", label: "Moroccan", countryCode: "MA" },
  { value: "mosotho", label: "Mosotho", countryCode: "LS" },
  { value: "motswana", label: "Motswana", countryCode: "BW" },
  { value: "mozambican", label: "Mozambican", countryCode: "MZ" },
  { value: "namibian", label: "Namibian", countryCode: "NA" },
  { value: "nauruan", label: "Nauruan", countryCode: "NR" },
  { value: "nepalese", label: "Nepalese", countryCode: "NP" },
  { value: "new_zealander", label: "New Zealander", countryCode: "NZ" },
  { value: "ni_vanuatu", label: "Ni-Vanuatu", countryCode: "VU" },
  { value: "nicaraguan", label: "Nicaraguan", countryCode: "NI" },
  { value: "nigerien", label: "Nigerien", countryCode: "NE" },
  { value: "nigerian", label: "Nigerian", countryCode: "NG" },
  { value: "north_korean", label: "North Korean", countryCode: "KP" },
  { value: "northern_irish", label: "Northern Irish", countryCode: "GB" },
  { value: "norwegian", label: "Norwegian", countryCode: "NO" },
  { value: "omani", label: "Omani", countryCode: "OM" },
  { value: "pakistani", label: "Pakistani", countryCode: "PK" },
  { value: "palauan", label: "Palauan", countryCode: "PW" },
  { value: "panamanian", label: "Panamanian", countryCode: "PA" },
  { value: "papua_new_guinean", label: "Papua New Guinean", countryCode: "PG" },
  { value: "paraguayan", label: "Paraguayan", countryCode: "PY" },
  { value: "peruvian", label: "Peruvian", countryCode: "PE" },
  { value: "polish", label: "Polish", countryCode: "PL" },
  { value: "portuguese", label: "Portuguese", countryCode: "PT" },
  { value: "qatari", label: "Qatari", countryCode: "QA" },
  { value: "romanian", label: "Romanian", countryCode: "RO" },
  { value: "russian", label: "Russian", countryCode: "RU" },
  { value: "rwandan", label: "Rwandan", countryCode: "RW" },
  { value: "saint_lucian", label: "Saint Lucian", countryCode: "LC" },
  { value: "salvadoran", label: "Salvadoran", countryCode: "SV" },
  { value: "samoan", label: "Samoan", countryCode: "WS" },
  { value: "san_marinese", label: "San Marinese", countryCode: "SM" },
  { value: "sao_tomean", label: "Sao Tomean", countryCode: "ST" },
  { value: "saudi", label: "Saudi", countryCode: "SA" },
  { value: "scottish", label: "Scottish", countryCode: "GB" },
  { value: "senegalese", label: "Senegalese", countryCode: "SN" },
  { value: "serbian", label: "Serbian", countryCode: "RS" },
  { value: "seychellois", label: "Seychellois", countryCode: "SC" },
  { value: "sierra_leonean", label: "Sierra Leonean", countryCode: "SL" },
  { value: "singaporean", label: "Singaporean", countryCode: "SG" },
  { value: "slovakian", label: "Slovakian", countryCode: "SK" },
  { value: "slovenian", label: "Slovenian", countryCode: "SI" },
  { value: "solomon_islander", label: "Solomon Islander", countryCode: "SB" },
  { value: "somali", label: "Somali", countryCode: "SO" },
  { value: "south_african", label: "South African", countryCode: "ZA" },
  { value: "south_korean", label: "South Korean", countryCode: "KR" },
  { value: "south_sudanese", label: "South Sudanese", countryCode: "SS" },
  { value: "spanish", label: "Spanish", countryCode: "ES" },
  { value: "sri_lankan", label: "Sri Lankan", countryCode: "LK" },
  { value: "sudanese", label: "Sudanese", countryCode: "SD" },
  { value: "surinamer", label: "Surinamer", countryCode: "SR" },
  { value: "swazi", label: "Swazi", countryCode: "SZ" },
  { value: "swedish", label: "Swedish", countryCode: "SE" },
  { value: "swiss", label: "Swiss", countryCode: "CH" },
  { value: "syrian", label: "Syrian", countryCode: "SY" },
  { value: "taiwanese", label: "Taiwanese", countryCode: "TW" },
  { value: "tajik", label: "Tajik", countryCode: "TJ" },
  { value: "tanzanian", label: "Tanzanian", countryCode: "TZ" },
  { value: "thai", label: "Thai", countryCode: "TH" },
  { value: "togolese", label: "Togolese", countryCode: "TG" },
  { value: "tongan", label: "Tongan", countryCode: "TO" },
  { value: "trinidadian_or_tobagonian", label: "Trinidadian or Tobagonian", countryCode: "TT" },
  { value: "tunisian", label: "Tunisian", countryCode: "TN" },
  { value: "turkish", label: "Turkish", countryCode: "TR" },
  { value: "tuvaluan", label: "Tuvaluan", countryCode: "TV" },
  { value: "ugandan", label: "Ugandan", countryCode: "UG" },
  { value: "ukrainian", label: "Ukrainian", countryCode: "UA" },
  { value: "uruguayan", label: "Uruguayan", countryCode: "UY" },
  { value: "uzbekistani", label: "Uzbekistani", countryCode: "UZ" },
  { value: "venezuelan", label: "Venezuelan", countryCode: "VE" },
  { value: "vietnamese", label: "Vietnamese", countryCode: "VN" },
  { value: "welsh", label: "Welsh", countryCode: "GB" },
  { value: "yemenite", label: "Yemenite", countryCode: "YE" },
  { value: "zambian", label: "Zambian", countryCode: "ZM" },
  { value: "zimbabwean", label: "Zimbabwean", countryCode: "ZW" },
];

// Popular nationalities for Vietnam Young Lions competition (can be used for default ordering)
export const popularNationalities = [
  "vietnamese",
  "american", 
  "british",
  "australian",
  "canadian",
  "singaporean",
  "malaysian",
  "thai",
  "japanese",
  "south_korean",
  "chinese",
  "indian",
  "french",
  "german",
];

// Helper function to get nationality options with popular ones first
export const getNationalityOptions = (): Array<{ value: string; label: string }> => {
  // Get popular nationalities in the exact order specified in popularNationalities array
  const popular = popularNationalities
    .map(value => nationalities.find(n => n.value === value))
    .filter(n => n !== undefined)
    .map(n => ({ value: n!.value, label: n!.label }));
  
  // Get remaining nationalities alphabetically
  const others = nationalities
    .filter(n => !popularNationalities.includes(n.value))
    .map(n => ({ value: n.value, label: n.label }));
  
  return [
    ...popular,
    ...others
  ];
};

// Helper function to search nationalities
export const searchNationalities = (query: string): Array<{ value: string; label: string }> => {
  const lowercaseQuery = query.toLowerCase();
  return nationalities
    .filter(n => 
      n.label.toLowerCase().includes(lowercaseQuery) || 
      n.value.toLowerCase().includes(lowercaseQuery)
    )
    .map(n => ({ value: n.value, label: n.label }));
};

export default nationalities;